import { ItemType } from '@vista-digital/ocapi-types/v1';
import { getZeroMonetaryValue } from '../../../../utils/monetary-value-utils';
import { createUUID } from '../../../../utils/uuid-utils';
import { getInProgressItemModifierGroupsForItem } from './get-in-progress-item-modifier-groups-for-item';
import { updateInProgressItemIsValid } from './update-in-progress-item-is-valid';
import { updateInProgressItemTotalPrice } from './update-in-progress-item-total-price';
import { updateInProgressItemTotalSavings } from './update-in-progress-item-total-savings';
export const createDefaultInProgressNormalItem = (item, selectedPrice) => {
    const modifierGroups = getInProgressItemModifierGroupsForItem(item);
    const inProgressItem = {
        type: ItemType.Normal,
        id: createUUID(),
        item,
        selectedPrice,
        isValid: false,
        initiallyDisplayAsValid: !!modifierGroups.length,
        modifierGroups,
        totalPrice: getZeroMonetaryValue(),
        totalSavings: getZeroMonetaryValue()
    };
    updateInProgressItemIsValid(inProgressItem);
    updateInProgressItemTotalSavings(inProgressItem);
    updateInProgressItemTotalPrice(inProgressItem);
    return inProgressItem;
};
